import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const PublicSettingsCtx = createContext({
  settings: {},
  loading: true,
  refresh: () => {},
});

const DEFAULTS = {
  BUSINESS_NAME: "ColourMatch",
  WEBSITE_URL: "https://colourmatch.au",
  CONTACT_EMAIL_SUPPORT: "support@colourmatch.au",
  CONTACT_EMAIL_BILLING: "support@colourmatch.au",
  CONTACT_PHONE: "",
  BUSINESS_ABN: "",
  MAINTENANCE_BANNER: "",
  MAINTENANCE_MODE: false,
  FEATURE_GALLERY_PROJECT_TYPE_FILTER: false,
  PAINTERPRO_ENABLED: false,
  PAINTERPRO_APPLICATIONS_OPEN: true,
  PAINTERPRO_PROFILES_INDEXABLE: false,
};

export function PublicSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/public/settings");
      setSettings({ ...DEFAULTS, ...(r.data || {}) });
    } catch {
      // Keep defaults on failure — public site must still render.
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <PublicSettingsCtx.Provider value={{ settings, loading, refresh }}>
      {children}
    </PublicSettingsCtx.Provider>
  );
}

export function usePublicSettings() {
  return useContext(PublicSettingsCtx);
}
